var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySettlementAccounts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 167,
    viewBox: "0 0 220 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80.5,
    r: 80,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12.5,
    r: 8,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 142.5,
    r: 6,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 138.5,
    r: 10,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46.5,
    r: 10,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 11.5,
    r: 7,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_473_30661)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22.5,
    width: 166,
    height: 104,
    rx: 6,
    fill: "url(#paint0_linear_473_30661)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0703,
    y: 46.686,
    width: 29.0233,
    height: 21.7674,
    rx: 2,
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.837,
    cy: 53.9417,
    r: 12.093,
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.325,
    cy: 53.9417,
    r: 12.093,
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0703 110.779C41.0703 109.443 42.1532 108.36 43.4889 108.36H67.675C69.0107 108.36 70.0936 109.443 70.0936 110.779C70.0936 112.115 69.0107 113.198 67.675 113.198H43.4889C42.1532 113.198 41.0703 112.115 41.0703 110.779Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3494 110.779C77.3494 109.443 78.4322 108.36 79.768 108.36H103.954C105.29 108.36 106.373 109.443 106.373 110.779C106.373 112.115 105.29 113.198 103.954 113.198H79.768C78.4322 113.198 77.3494 112.115 77.3494 110.779Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.628 110.779C113.628 109.443 114.711 108.36 116.047 108.36H140.233C141.569 108.36 142.652 109.443 142.652 110.779C142.652 112.115 141.569 113.198 140.233 113.198H116.047C114.711 113.198 113.628 112.115 113.628 110.779Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.908 110.779C149.908 109.443 150.99 108.36 152.326 108.36H176.512C177.848 108.36 178.931 109.443 178.931 110.779C178.931 112.115 177.848 113.198 176.512 113.198H152.326C150.99 113.198 149.908 112.115 149.908 110.779Z",
    fill: "#D0D5DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_473_30661)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 94.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 126.5L110 123.5M110 123.5L113 126.5M110 123.5V130.5M120 119.5H100M103.5 128.5H103.2C102.08 128.5 101.52 128.5 101.092 128.282C100.716 128.09 100.41 127.784 100.218 127.408C100 126.98 100 126.42 100 125.3V117.7C100 116.58 100 116.02 100.218 115.592C100.41 115.216 100.716 114.91 101.092 114.718C101.52 114.5 102.08 114.5 103.2 114.5H116.8C117.92 114.5 118.48 114.5 118.908 114.718C119.284 114.91 119.59 115.216 119.782 115.592C120 116.02 120 116.58 120 117.7V125.3C120 126.42 120 126.98 119.782 127.408C119.59 127.784 119.284 128.09 118.908 128.282C118.48 128.5 117.92 128.5 116.8 128.5H116.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_473_30661",
    x: 7,
    y: 22.5,
    width: 206,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_473_30661"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473_30661"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_473_30661"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_473_30661",
    result: "effect2_dropShadow_473_30661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_473_30661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_473_30661",
    x: 74,
    y: 86.5,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_473_30661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_473_30661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_473_30661",
    x1: 32.7809,
    y1: 125.269,
    x2: 29.758,
    y2: 30.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySettlementAccounts);
export default __webpack_public_path__ + "static/media/EmptySettlementAccounts.7470bb178aeef169da7dbc2e9d436722.svg";
export { ForwardRef as ReactComponent };